@if (isLoading()) {
    <div class="loader" role="status" aria-live="polite">
        <span class="visually-hidden">Loading…</span>
    </div>
}
